import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-lms1",
  "use": "icon-lms1-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-lms1\"><path fill=\"#696969\" d=\"M608 768 608 576 960 704 960 640C960 604.653776 934.68503 562.191834 903.445107 545.151878L608 384 608 128C608 96 576.218694 64.002495 512 64.002495 447.781306 64.002495 416 96 416 128L416 384 120.55489 545.151878C89.320486 562.188826 64 604.407348 64 640L64 704 416 576 416 768 288 915.344186 288 955.502784 320 940.968032 320 960 512 896 703.785229 960 703.785229 940.968032 736 955.502784 736 915.373984 608 768Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol